/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
  props: ["errors", "showAmount", "amount"],
  data() {
    return {
      showingHelp: false,
      form: {
        amount: this.amount,
      }
    }
  },
  watch: {
    amount(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.form.amount = newVal;
      }
    },
  }
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-pix" },
    [
      _vm.showAmount
        ? _c("form-group", {
            attrs: {
              "is-money": "true",
              label: "Valor no pix",
              placeholder: "Valor no pix",
              icon: "icon-money",
              disabled: true,
              errors: _vm.errors.amount,
              id: "amount",
              type: "tel",
            },
            model: {
              value: _vm.form.amount,
              callback: function ($$v) {
                _vm.$set(_vm.form, "amount", $$v)
              },
              expression: "form.amount",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      !_vm.showAmount
        ? _c("div", { staticClass: "row text-center" }, [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
          ])
        : _c("div", { staticClass: "text-left" }, [
            _vm._m(4),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _vm._m(6),
          ]),
    ],
    1
  )
}
var __vue_staticRenderFns__ = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-flex justify-content-center align-items-center py-3 py-lg-4",
      },
      [
        _c("div", { staticClass: "lead text-secondary mr-2" }, [
          _vm._v("Pague com"),
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "logo",
          attrs: { src: "/static/images/pix-logo.svg" },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-4 py-3 py-lg-4" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: "/static/images/pix-icon-1.png" },
      }),
      _vm._v(" "),
      _c("h5", [_vm._v("Pagamento imediato")]),
      _vm._v(" "),
      _c("div", { staticClass: "description px-xl-4" }, [
        _vm._v(
          "Faça seus pagamentos em segundos sem pagar nada a mais por isso."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-4 py-3 py-lg-4" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: "/static/images/pix-icon-2.png" },
      }),
      _vm._v(" "),
      _c("h5", [_vm._v("Simples")]),
      _vm._v(" "),
      _c("div", { staticClass: "description px-xl-4" }, [
        _vm._v(
          "Basta abrir o aplicativo do seu banco, procurar o PIX e escanear o QRcode."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-4 py-3 py-lg-4" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: "/static/images/pix-icon-3.png" },
      }),
      _vm._v(" "),
      _c("h5", [_vm._v("100% Seguro")]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(
          "O pagamento com PIX foi desenvolvido pelo Banco Central para facilitar seus pagamentos."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex py-3" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: "/static/images/pix-icon-1.png" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column pl-2" }, [
        _c("span", [_vm._v("Pagamento imediato")]),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "Faça seus pagamentos em segundos sem pagar nada a mais por isso."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex py-3" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: "/static/images/pix-icon-2.png" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column pl-2" }, [
        _c("span", [_vm._v("Simples")]),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "Basta abrir o aplicativo do seu banco, procurar o PIX e escanear o QRcode."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex py-3" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: "/static/images/pix-icon-3.png" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column pl-2" }, [
        _c("span", [_vm._v("100% Seguro")]),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "O pagamento com PIX foi desenvolvido pelo Banco Central para facilitar seus pagamentos."
          ),
        ]),
      ]),
    ])
  },
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-397cabf8_0", { source: ".form-pix .logo {\n  max-height: 48px;\n}\n.form-pix .icon {\n  max-height: 32px;\n}\n.form-pix .description {\n  color: #928F98;\n  font-size: 14px;\n}\n\n/*# sourceMappingURL=form-pix.vue.map */", map: {"version":3,"sources":["frontend/components/form-pix.vue","form-pix.vue"],"names":[],"mappings":"AAoFA;EACA,gBAAA;ACnFA;ADqFA;EACA,gBAAA;ACnFA;ADqFA;EACA,cAAA;EACA,eAAA;ACnFA;;AAEA,uCAAuC","file":"form-pix.vue","sourcesContent":["<template>\n  <div class=\"form-pix\">\n    <form-group\n      v-if=\"showAmount\"\n      is-money=\"true\"\n      label=\"Valor no pix\"\n      placeholder=\"Valor no pix\"\n      icon=\"icon-money\"\n      :disabled=\"true\"\n      v-model=\"form.amount\"\n      :errors=\"errors.amount\"\n      id=\"amount\"\n      type=\"tel\"\n    />\n    <div class=\"d-flex justify-content-center align-items-center py-3 py-lg-4\">\n      <div class=\"lead text-secondary mr-2\">Pague com</div>\n      <img src=\"/static/images/pix-logo.svg\" class=\"logo\" />\n    </div>\n    <div class=\"row text-center\" v-if=\"!showAmount\">\n      <div class=\"col-lg-4 py-3 py-lg-4\">\n        <img src=\"/static/images/pix-icon-1.png\" class=\"icon\"  />\n        <h5>Pagamento imediato</h5>\n        <div class=\"description px-xl-4\">Faça seus pagamentos em segundos sem pagar nada a mais por isso.</div>\n      </div>\n      <div class=\"col-lg-4 py-3 py-lg-4\">\n        <img src=\"/static/images/pix-icon-2.png\" class=\"icon\"  />\n        <h5>Simples</h5>\n        <div class=\"description px-xl-4\">Basta abrir o aplicativo do seu banco, procurar o PIX e escanear o QRcode.</div>\n      </div>\n      <div class=\"col-lg-4 py-3 py-lg-4\">\n        <img src=\"/static/images/pix-icon-3.png\" class=\"icon\"  />\n        <h5>100% Seguro</h5>\n        <div class=\"description\">O pagamento com PIX foi desenvolvido pelo Banco Central para facilitar seus pagamentos.</div>\n      </div>\n    </div>\n    <div v-else class=\"text-left\" >\n      <div class=\"d-flex py-3\">\n        <img src=\"/static/images/pix-icon-1.png\" class=\"icon\"  />\n        <div class=\"d-flex flex-column pl-2\">\n          <span>Pagamento imediato</span>\n          <small>Faça seus pagamentos em segundos sem pagar nada a mais por isso.</small>\n        </div>\n      </div>\n      <div class=\"d-flex py-3\">\n        <img src=\"/static/images/pix-icon-2.png\" class=\"icon\"  />\n        <div class=\"d-flex flex-column pl-2\">\n          <span>Simples</span>\n          <small>Basta abrir o aplicativo do seu banco, procurar o PIX e escanear o QRcode.</small>\n        </div>  \n      </div>\n      <div class=\"d-flex py-3\">\n        <img src=\"/static/images/pix-icon-3.png\" class=\"icon\"  />\n        <div class=\"d-flex flex-column pl-2\">\n          <span>100% Seguro</span>\n          <small>O pagamento com PIX foi desenvolvido pelo Banco Central para facilitar seus pagamentos.</small>\n        </div>  \n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nexport default {\n  props: [\"errors\", \"showAmount\", \"amount\"],\n  data() {\n    return {\n      showingHelp: false,\n      form: {\n        amount: this.amount,\n      }\n    }\n  },\n  watch: {\n    amount(newVal, oldVal) {\n      if (newVal !== oldVal) {\n        this.form.amount = newVal;\n      }\n    },\n  }\n}\n</script>\n\n<style lang=\"scss\">\n.form-pix {\n  .logo {\n    max-height: 48px;\n  }\n  .icon {\n    max-height: 32px;\n  }\n  .description {\n    color: #928F98;\n    font-size: 14px;\n  }\n}\n</style>",".form-pix .logo {\n  max-height: 48px;\n}\n.form-pix .icon {\n  max-height: 32px;\n}\n.form-pix .description {\n  color: #928F98;\n  font-size: 14px;\n}\n\n/*# sourceMappingURL=form-pix.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/form-pix.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__